import { render, staticRenderFns } from "./ScansGallery.vue?vue&type=template&id=13d94c03&scoped=true&"
import script from "./ScansGallery.vue?vue&type=script&lang=js&"
export * from "./ScansGallery.vue?vue&type=script&lang=js&"
import style0 from "./ScansGallery.vue?vue&type=style&index=0&id=13d94c03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d94c03",
  null
  
)

export default component.exports